
/*
 * Date: 2025
 * Description: Users rows reworked for table
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { Box , Grid , IconButton, Typography } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_table_row_props } from "../../interfaces/utility.interface";

//Utils
import { timestampToDate } from "../../utils/utility";

//Icons
import { DeleteForever } from "@mui/icons-material";
import BlockIcon from '@mui/icons-material/Block';

const RunsRow = ( props : i_table_row_props) : ReactElement => {
    const R = props.row
    const H = props.headers
    //Need to remaster Grid with new MUI versions
    return (
        <Box sx={{ borderLeft : '1px solid #D3D3D3' , borderRight : '1px solid #D3D3D3' , borderBottom : '1px solid #D3D3D3'}}>
            <Grid container sx={{ padding : '6px'}}>
                <Grid size={H[0].portion} sx={{ opacity : R.disabled ? 0.5 : 1}}>
                    <Box sx={{ display : 'flex' , marginTop : '0.4vh' ,opacity : R.disabled ? 0.5 : 1 }}>
                        <Typography sx={{ fontSize : 14 }}>{timestampToDate(R.timestamp , 'long')}</Typography>
                    </Box>
                </Grid>
                <Grid size={H[1].portion} sx={{ alignSelf : 'center'}}>
                    <Typography sx={{ alignSelf : 'center' , fontSize : 14 , opacity : R.disabled ? 0.5 : 1}}>{R.event}</Typography>
                </Grid>
                <Grid size={H[2].portion} sx={{ alignSelf : 'center' , display : 'flex'}}>
                    <Typography sx={{ alignSelf : 'center' , fontSize : 14 , opacity : R.disabled ? 0.5 : 1}}>{R.index}</Typography>
                </Grid>
                <Grid size={H[3].portion} sx={{ alignSelf : 'center' , opacity : R.disabled ? 0.5 : 1}}>
                    <Typography sx={{ fontSize : 14 }}>{ R.finish_timestamp === 0 ? 'Not finished' : timestampToDate(R.finish_timestamp , 'long')}</Typography>
                </Grid>
                <Grid size={H[4].portion} sx={{ alignSelf : 'center' }}>
                    <IconButton onClick={() => props.callback(R , 'disable')}>
                        <BlockIcon />
                    </IconButton>
                    <IconButton onClick={() => props.callback(R , 'delete')}>
                        <DeleteForever />
                    </IconButton>
                </Grid>
          
            </Grid>
        </Box>
    )
}

export default RunsRow